import React from 'react';
import { PencilIcon, TrashIcon, DocumentIcon } from '@heroicons/react/24/outline';

const ResourceCard = ({ resource, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 flex flex-col justify-between hover:shadow-md transition-all duration-300">
            <div>
                {/* Header Badge */}
                <div className="flex items-center justify-between mb-4">
                    <span className="px-3 py-1 bg-[#283079]/10 text-[#283079] text-xs font-semibold rounded-full">
                        {resource.category}
                    </span>
                    {resource.language && (
                        <span className="px-3 py-1 bg-amber-50 text-amber-600 text-xs font-semibold rounded-full border border-amber-100">
                            {resource.language}
                        </span>
                    )}
                    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${
                        resource.is_active
                            ? 'bg-green-50 text-green-700 border border-green-100'
                            : 'bg-slate-50 text-slate-500 border border-slate-200'
                    }`}>
                        {resource.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold text-slate-800 mb-2 line-clamp-2">
                    {resource.title}
                </h3>

                {/* File Info */}
                <div className="flex items-center gap-2 text-slate-500 text-sm bg-slate-50 p-3 rounded-xl mb-4 border border-slate-100">
                    <DocumentIcon className="h-5 w-5 text-slate-400 flex-shrink-0" />
                    <span className="truncate font-medium flex-1">
                        {resource.file_url ? resource.file_url.split('/').pop() : 'No file uploaded'}
                    </span>

                </div>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-end gap-2 pt-4 border-t border-slate-50">
                <button
                    onClick={() => onEdit(resource)}
                    className="p-2 hover:bg-slate-100 text-slate-600 hover:text-primary-600 rounded-lg transition-colors"
                    title="Edit Resource"
                >
                    <PencilIcon className="h-5 w-5" />
                </button>
                <button
                    onClick={() => onDelete(resource.id)}
                    className="p-2 hover:bg-red-50 text-slate-600 hover:text-red-600 rounded-lg transition-colors"
                    title="Delete Resource"
                >
                    <TrashIcon className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
};

export default ResourceCard;
